import { setupMobX } from '../../../../../../../util/setupMobX';
import { observable, makeObservable, action, runInAction } from 'mobx';
import { showErrorNotification } from '../../../../../../../component/notification';
import { wonRaffles } from '../../../../../../../request/authenticated-requests/raffle';
import { RaffleCollectionStatus, RafflesResDto } from '@web/common';

export class WonRafflesStore {
  @observable public loading: boolean = false;
  @observable public uncollectedRaffles: RafflesResDto | null = null;

  constructor() {
    makeObservable(this);
  }

  @action public resetStore() {
    this.uncollectedRaffles = null;
  }

  @action public loadUncollectedRaffles() {
    if (this.loading) return;

    this.loading = true;

    wonRaffles(RaffleCollectionStatus.Uncollected)
      .then((res) =>
        runInAction(() => {
          this.uncollectedRaffles = res;
        }),
      )
      .catch(() => showErrorNotification())
      .finally(() => runInAction(() => (this.loading = false)));
  }

  public get hasUncollectedRaffles() {
    return (
      this.uncollectedRaffles !== null && this.uncollectedRaffles.length > 0
    );
  }

  public get raffleCount() {
    return this.uncollectedRaffles?.length ?? 0;
  }

  // theoretically a participant could win multiple raffles at once,
  // but we want to show only the most recent one in the banner,
  // so we sort them by end date and return the most recent one
  public get mostRecentRaffle() {
    if (!this.hasUncollectedRaffles) return null;

    // Sort by end date descending and return the most recent one
    const sorted = [...this.uncollectedRaffles!].sort((a, b) => {
      const endDateA = a.fields.endDate['en-US'];
      const endDateB = b.fields.endDate['en-US'];
      return endDateB.toMillis() - endDateA.toMillis();
    });

    return sorted[0];
  }
}

const { provider, useStore } = setupMobX<WonRafflesStore>();
export const useWonRafflesStore = useStore;
export const WonRafflesStoreProvider = provider;
